import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[sipLoadCompHelper]',
    standalone: false
})
export class LoadCompHelperDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
